import(/* webpackMode: "eager" */ "/home/runner/work/kst-frontend/kst-frontend/app/find-a-stick-to-rent/page.tsx")